<template>
  <div>
    <h3>Model View</h3>

    <div class="card" v-if="model !== null">
      <div class="card-body">
        <p>신청자 : {{ model.name }}</p>
        <p>연락처 : {{ model.contact }}</p>
        <p>나이 : {{ model.age }}</p>
        <p>성별 : {{ model.sex === 'M' ? '남자' : (model.sex === 'F' ? '여자' : '') }}</p>

        <div v-html="model.content"></div>

        <p>SMS 수신 동의 : {{ model.agreeSms }}</p>

        <p>신청일 : {{ model.createAt | moment('YYYY-MM-DD HH:mm:ss')}}</p>

        <div class="mt-3">
          <h5>Comments</h5>
          <div class="media text-muted pt-3" v-for="(item) in model.comments" :key="item.id">
            <div class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
              <div class="d-flex justify-content-between align-items-center w-100">
                <strong class="text-gray-dark"></strong>
                <small>{{item.createAt | moment('YYYY-MM-DD HH:mm:ss')}}</small>
              </div>
              <span class="d-block" v-html="item.content" />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <vue-editor
          class="mb-3"
          v-model="comment"
          data-vv-name="comment"
          v-validate="'required'"
        />
        <div class="invalid-feedback" :class="{'d-block': errors.has('comment') }" v-if="errors.has('comment')">
          {{errors.first('comment')}}
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="submitComment">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
  name: 'AdminModelView',
  components: {
    VueEditor,
  },
  data() {
    return {
      model: null,
      comment: '',
    };
  },
  mounted() {
    // if(this.$route)
    if (this.$route.params && this.$route.params.id) {
      this.refresh();
    }
  },
  methods: {
    refresh() {
      this.axios.get(`/admin/counsel/model/${this.$route.params.id}`)
        .then(({ data }) => {
          this.model = data;
        })
        .catch(() => {
          this.$router.push({ name: 'adminModelList' });
        });
    },
    async submitComment() {
      await this.$validator.validateAll();

      this.$axios.post('/admin/counsel/model/comment', { counselId: this.model.id, content: this.comment })
        .then(() => {
          this.comment = '';
          this.refresh();
        });
    },
  },
};
</script>

<style scoped>

</style>
